import {TableDefinition} from "../table/table-definition";
import {TableModel} from "../table/table-model";
import {ViewDefinition} from "../view/view-definition";
import {ViewModel} from "../view/view-model";
import {UtilService} from "../../services/util/util.service";
import {Subject} from "rxjs";
import {FormDisplayType} from "../type/form-display-type.enum";

// NOTE this class has had methods added, that are found on the KO implementation, sufficient to get
// lists implemented. It also supports the content page footer component on detail forms.
//
// It needs to be looked at again when detail forms are reimplemented.
//
// The KO methods should not be used in NG code.
//
export abstract class ContentModel {
  readonly viewModel: ViewModel;      // Wrapper around a view definition
  readonly tableModel: TableModel;    // Wrapper around a table definition
  data: any;                // Record data, either a single record (Detail) or multiple records (List)
  readonly _data = {                  // Holder of various properties such as event executor
    _eventExecutor: undefined,
    _tableClass: undefined,
    _formDisplayType: undefined,
    _formContext: undefined,
  };

  // Subject we use to send events to the containing Angular component.
  changed$: Subject<any> = new Subject<any>();

  // KO properties
  readonly _viewName: string;
  readonly _viewDefinition: any;

  // Cached conversion to NG. This may not be necessary.
  _convertedViewModel: any;

  protected constructor(viewDefinitionOrModel: ViewDefinition | ViewModel, tableDefinitionOrModel: TableDefinition | TableModel, data?: any) {
    this.viewModel = (viewDefinitionOrModel instanceof ViewModel) ? viewDefinitionOrModel : ViewModel.create(viewDefinitionOrModel);
    this.tableModel = (tableDefinitionOrModel instanceof TableModel) ? tableDefinitionOrModel : TableModel.create(tableDefinitionOrModel);
    this.data = data;

    // KO properties
    this._viewName = this.viewModel.getName();
    this._viewDefinition = this.viewModel.viewDefinition();
  }

  // NG methods

  abstract update(data: any, retainFieldValues?: boolean);

  refresh(id: string, updateType: string) {
    this.changed$.next("refresh");
  }

  getTableName() {
    return this.viewModel.viewDefinition().table;
  }

  getAspect() {
    return this.viewModel.viewDefinition().aspect;
  }

  getEventExecutor() {
    return this._data._eventExecutor;
  }

  setEventExecutor(eventExecutor: any) {
    this._data._eventExecutor = eventExecutor;
  }

  // KO methods

  _update(data: any, retainFieldValues?: boolean) {
    this.update(data, retainFieldValues);
  }

  selectRecord() {
    UtilService.notImplemented("ContentModel", "selectRecord");
  }

  // These journal entry methods are only valid for DetailContentModel.
  // They won't be implemented until we have a component that represents the journal (or indeed the entire form).

  addJournalEntry(fieldName: string, text: string, createdBy: string, createdOn: string, id: string, template: string, isEncoded: boolean) {
    UtilService.notImplemented("ContentModel", "addJournalEntry");
  }

  clearJournalEntry(fieldName: string, id: string) {
    UtilService.notImplemented("ContentModel", "clearJournalEntry");
  }

  clearJournalEntries() {
    UtilService.notImplemented("ContentModel", "clearJournalEntries");
  }
}
